module.exports = __webpack_public_path__ + "img/otp-intro.8ce281f5.png";